module.exports = __webpack_public_path__ + "img/1.064220ee.jpg";